/* Pon aqui codigo personalizado de js */


/* cambiar el icono del account */
document.addEventListener('DOMContentLoaded', function () {
  // Paso 1: Seleccionar el contenedor del ícono
  const iconContainer = document.querySelector('.t4s-site-nav__icon.t4s-site-nav__account');
  
  if (iconContainer) {
    // Paso 2: Definir las URLs de los íconos
    const lightIconUrl = 'https://cdn.shopify.com/s/files/1/0425/4272/7333/files/icono-blanco.png';
    const darkIconUrl = 'https://cdn.shopify.com/s/files/1/0425/4272/7333/files/Diseno_sin_titulo_2_05e634c6-5a25-48bb-bf6a-dc9c51e43564.png';
    
    // Paso 3: Crear elementos para el ícono
    const linkElement = document.createElement('a');
    linkElement.href = '/account';
    linkElement.style.textDecoration = 'none';
    linkElement.style.display = 'block';
    
    const wrapper = document.createElement('div');
    wrapper.style.width = '30px';
    wrapper.style.height = '30px';
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'center';
    wrapper.style.overflow = 'hidden';
    
    const imgElement = document.createElement('img');
    imgElement.id = 'account-icon-image';
    imgElement.alt = 'Cuenta';
    imgElement.style.maxWidth = '100%';
    imgElement.style.maxHeight = '100%';
    
    // Determinar el ícono inicial
    const currentPath = window.location.pathname;
    imgElement.src = currentPath === '/' ? lightIconUrl : darkIconUrl;
    
    // Estructurar los elementos
    wrapper.appendChild(imgElement);
    linkElement.appendChild(wrapper);
    iconContainer.innerHTML = '';
    iconContainer.appendChild(linkElement);
    
    // Función para verificar y actualizar el ícono
    function updateIcon() {
      const header = document.querySelector('header');
      if (!header) return;
      
      // Verificar si el header tiene la clase sticky o está fijado
      const isSticky = header.classList.contains('shopify-section-header-sticky') || 
                       window.getComputedStyle(header).position === 'fixed' ||
                       window.scrollY > 50; // Forzar cambio después de 50px de scroll
      
      // Forzar el cambio de ícono basado en el estado sticky
      imgElement.src = isSticky ? darkIconUrl : (currentPath === '/' ? lightIconUrl : darkIconUrl);
    }
    
    // Verificar inicialmente
    updateIcon();
    
    // Usar eventos de scroll y resize para detectar cambios
    window.addEventListener('scroll', updateIcon);
    window.addEventListener('resize', updateIcon);
    
    // También verificar periódicamente
    setInterval(updateIcon, 500);
  } else {
    console.error('No se encontró el contenedor del ícono.');
  }
});

/* Traducir el mensaje del heading de la lista de deseos */
document.addEventListener("DOMContentLoaded", function() {
    var wishlistText = document.querySelector('.t4s-desc-head p');
    if (wishlistText) {
        wishlistText.textContent = "Ver tus productos de la lista de deseos";
    }
});

/* Traducir el mesaje de la vista rapida de los porductos complmentarios*/
document.addEventListener('DOMContentLoaded', () => {
    // Función que traduce el botón si existe
    const translateButton = (node) => {
      const btn = node.querySelector('.t4s-pr__btn-detail a');
      if (btn) {
        btn.innerHTML = 'Ver detalles completos <svg class="t4s-btn-icon" viewBox="0 0 14 10"><use xlink:href="#t4s-icon-btn"></use></svg>';
      }
    };

    // Traducir si ya existen botones al cargar
    document.querySelectorAll('.t4s-pr__btn-detail').forEach((el) => translateButton(el));

    // Crear un observer para detectar elementos nuevos
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Asegura que sea un nodo de tipo elemento
            if (node.matches('.t4s-pr__btn-detail') || node.querySelector('.t4s-pr__btn-detail')) {
              translateButton(node);
            }
          }
        });
      });
    });

    // Iniciar el observer en todo el body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
